import { render, staticRenderFns } from "./cModalDetalleCompra.vue?vue&type=template&id=4e3b169e&scoped=true"
import script from "./cModalDetalleCompra.vue?vue&type=script&lang=js"
export * from "./cModalDetalleCompra.vue?vue&type=script&lang=js"
import style0 from "./cModalDetalleCompra.vue?vue&type=style&index=0&id=4e3b169e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3b169e",
  null
  
)

export default component.exports